import { useQuery } from '@tanstack/react-query';
export const useExploreQuery = () => {
    const segments = window.location.pathname.split('/');
    const solutionSegment = segments[segments.length - 1];
    const localeSegment = segments[1];
    return useQuery(['explore', solutionSegment, localeSegment], async () => {
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.append('locale', localeSegment);
        try {
            const response = await fetch(`/api/solutions/${solutionSegment}/explore?${urlSearchParams}`);
            return await response.json();
        }
        catch (error) {
            return error;
        }
    });
};
